export default __webpack_public_path__ + "static/media/compute-engine.e33f41e6.svg";